import { useRef, useEffect } from 'react';
import { flattenDeep } from 'lodash/fp';
import { useEventListener } from 'app/lib/hooks/useEventListener/useEventListener.js';

function gatherFiles(items) {
    const files = items.map((item) => item.getAsFile());

    return flattenDeep(files);
}

export function useDropFiles(targetElement, handler) {
    const savedHandler = useRef();
    const handleOnDrop = (event) => {
        if (event.dataTransfer && event.dataTransfer.items) {
            const items = Array.from(event.dataTransfer.items);
            savedHandler.current(gatherFiles(items));
        } else {
            savedHandler.current([]);
        }
    };

    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);

    useEventListener(targetElement, 'dragover');
    useEventListener(targetElement, 'drop', { callback: handleOnDrop });
}
